import React from 'react';
import { useTheme } from '../context/ThemeContext';
import Tooltip from './shared/Tooltip';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Tooltip content={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}>
    <button
      onClick={toggleTheme}
      className="flex items-center justify-center w-10 h-10 rounded-full border border-current/10 bg-current/5 hover:bg-current/10 transition-all active:scale-95 group"
    >
      <span className={`material-symbols-outlined text-[20px] transition-colors ${theme === 'light' ? 'text-blue-600' : 'text-yellow-400'}`}>
        {theme === 'light' ? 'dark_mode' : 'light_mode'}
      </span>
    </button>
    </Tooltip>
  );
};

export default ThemeToggle;
